import styled, { css } from 'styled-components';

const CollapsedIconStyles = css`
  transform: rotate(180deg);
`;

export const CollapseWithTitleWrapper = styled.div<{ collapsed: boolean }>`
  padding: 12px 12px;
  overflow: hidden;
  background: ${(props) => props.theme.colors.overlay};
  border-radius: ${(props) => props.theme.misc.borderRadiusSm};
  border: 1px solid rgba(0, 115, 247, 0.16);

  svg {
    color: ${(props) => props.theme.colors.brand};
    transition: ${(props) => props.theme.misc.transitionDurationSm} ease-in;
    ${(props) => props.collapsed && CollapsedIconStyles}
  }
`;

export const InstructionTitle = styled.p`
  margin-left: 10px;
  color: ${(props) => props.theme.colors.brand};
  ${(props) => props.theme.typography.subHeader2}
`;

const CollapsedStyles = css`
  max-height: 0;
  overflow: hidden;
  padding-bottom: 0;
  padding-top: 0;
`;

export const InstructionWrapper = styled.div<{ collapsed: boolean }>`
  padding: 12px 16px 12px 36px;
  transition: ${(props) => props.theme.misc.transitionDurationSm} ease-in;
  ${(props) => props.theme.typography.body};
  ${(props) => !props.collapsed && CollapsedStyles};
`;
